//GeneratorFlag:[NoChange]
import Process from './process';
import ProcessGroup from './process-group';
import ProcessFilter from './process-filter';

export default {Process, ProcessGroup, ProcessFilter}
export{Process, ProcessGroup, ProcessFilter}